import { Modal, addToast } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

import { AxiosResult, AxiosResultDefaultError } from '../../../api/request';
import { FacultyListItem } from '../../../api/requests/faculties';
import { useLayoutState } from '../../../hooks/useLayoutState';
import FacultyForm, { FacultyFormValues } from './FacultyForm';

interface FacultyModalProps {
  reloadList: () => void;
  recordToEdit: FacultyFormValues | null;
  show: boolean;
  toggleModal: () => void;
}

const getTranslationsTexts = (isEditionMode: boolean) => {
  const translationPreffix = 'maintainers.facultiesForm';
  return isEditionMode
    ? { success: 'common.messages.editSuccess' }
    : { success: `${translationPreffix}.createSuccess` };
};

const FacultyModal = ({
  recordToEdit,
  reloadList,
  show,
  toggleModal,
}: FacultyModalProps) => {
  const { t } = useTranslation();
  const { showErrorModal } = useLayoutState();

  const isEditionMode = !!recordToEdit;
  const texts = getTranslationsTexts(isEditionMode);

  const onSubmit = async (
    result: AxiosResult<FacultyListItem, AxiosResultDefaultError>,
  ) => {
    const { error, data } = result;
    if (error && error.code === 'CONNECTION') {
      showErrorModal();
    } else if (error) {
      addToast({
        icon: 'error',
        color: 'danger',
        text: t('common.errors.save'),
      });
    } else if (data) {
      reloadList();
      addToast({
        icon: 'success',
        color: 'success',
        text: t(texts.success),
      });
    }
  };

  return (
    <Modal isOpen={show} toggle={toggleModal} size="lg" unmountOnClose>
      <FacultyForm
        recordToEdit={recordToEdit}
        onSubmit={onSubmit}
        onCancel={toggleModal}
      />
    </Modal>
  );
};
export default FacultyModal;
